import {
  ExpansionStageDisplayName,
  RoofType,
  RoofTypeNumber
} from '../types/houseDetailsResponse'

export interface ExpansionStage {
  id: number
  name: string
  english_name: string
}

export type ExpansionStageValue = 'fitting' | 'lego' | 'keyready'

export type ConstructionMethodValue = 'prefab' | 'solid' | 'blockhouse'

export const CONSTRUCTION_METHOD_BY_NUMBER: Record<
  number,
  ConstructionMethodValue
> = {
  1: 'prefab',
  2: 'solid',
  3: 'blockhouse'
}

export const EXPANSION_STAGE_BY_NUMBER: Record<number, ExpansionStageValue> = {
  1: 'fitting',
  2: 'lego',
  3: 'keyready'
}

export const EXPANSION_STAGE_BY_DISPLAY_NAME: Record<
  ExpansionStageDisplayName,
  ExpansionStageValue
> = {
  Ausbauhaus: 'fitting',
  Bausatzhaus: 'lego',
  Schlüsselfertig: 'keyready'
}

export const ROOF_BY_NUMBER: Record<
  RoofTypeNumber,
  { type: RoofType; imageClassName: string }
> = {
  1: { type: 'saddle_roof', imageClassName: 'satteldach' },
  2: { type: 'hipped_roof', imageClassName: 'walmdach' },
  3: { type: 'flat_roof', imageClassName: 'flachdach' },
  4: { type: 'pent_roof', imageClassName: 'pultdach' },
  5: { type: 'tent_roof', imageClassName: 'zeltdach' },
  7: { type: 'mansard_roof', imageClassName: 'mansardendach' },
  8: { type: 'half_hipped_roof', imageClassName: 'kruppelwalmdach' },
  12: { type: 'round_roof', imageClassName: 'runddach' }
}

export const EXPANSION_STAGES_DISPLAY_ORDER = [3, 1, 2]

export const sortExpansionStagesByDisplayOrder = (
  a: ExpansionStage,
  b: ExpansionStage
): number => {
  return (
    EXPANSION_STAGES_DISPLAY_ORDER.indexOf(a.id) -
    EXPANSION_STAGES_DISPLAY_ORDER.indexOf(b.id)
  )
}
